import { PlusOutlined, ReloadOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import type React from "react"
import { memo } from "react"

interface RoleTableActionsProps {
  onAdd: () => void
  onRefresh: () => void
  loading?: boolean
}

/**
 * Component các nút thao tác trên bảng Vai trò (RoleTableActions)
 */
const RoleTableActions: React.FC<RoleTableActionsProps> = memo(({ onAdd, onRefresh, loading = false }) => {
  return (
    <div className="flex grow items-center justify-end gap-2">
      <Tooltip title="Thêm vai trò mới">
        <Button type="primary" size="small" icon={<PlusOutlined />} onClick={onAdd}>
          Thêm mới
        </Button>
      </Tooltip>

      <Tooltip title="Tải lại dữ liệu">
        <Button type="default" size="small" icon={<ReloadOutlined />} onClick={onRefresh} loading={loading} />
      </Tooltip>
    </div>
  )
})

RoleTableActions.displayName = "RoleTableActions"

export default RoleTableActions
